<template>
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '文件系统版本'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="130px" :rules="rules">
      <el-form-item label="文件系统版本" prop="PvName">
        <el-input
          v-model.trim="item.PvName"
          placeholder="文件系统版本"
        ></el-input>
      </el-form-item>
      <el-form-item label="产品型号名称" prop="DciProductModelIDs">
        <el-select
          v-model="item.DciProductModelIDs"
          multiple
          placeholder="请选择产品型号名称"
          style="width: 100%"
        >
          <el-option
            v-for="ele in modelList"
            :key="ele.ID"
            :label="ele.NameNumber"
            :value="ele.ID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布日期" prop="PublishAt">
        <el-date-picker
          v-model="item.PublishAt"
          style="width: 100%"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="产品默认版本" prop="IsDefault">
        <span slot="label">
          <span>
            <span
              >产品默认版本
              <el-popover
                placement="top-start"
                width="250"
                trigger="hover"
                content=""
                ><div>用于产品出库默认选择</div>
                <i
                  slot="reference"
                  class="el-icon-info"
                  style="color: #409eff"
                ></i>
              </el-popover>
            </span>
          </span>
        </span>
        <el-switch v-model="item.IsDefault"></el-switch>
      </el-form-item>
      <el-form-item label="是否公开发布" prop="IsPublic">
        <span slot="label">
          <span>
            <span
              >是否公开发布
              <el-popover
                placement="top-start"
                width="250"
                trigger="hover"
                content=""
                ><div>用于对外发布页使用</div>
                <i
                  slot="reference"
                  class="el-icon-info"
                  style="color: #409eff"
                ></i>
              </el-popover>
            </span>
          </span>
        </span>
        <el-switch v-model="item.IsPublic"></el-switch>
      </el-form-item>
      <el-form-item label="说明" prop="Desc">
        <el-input
          v-model.trim="item.Desc"
          :autosize="{ minRows: 3 }"
          type="textarea"
          placeholder="请输入说明"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        PvName: [
          { required: true, message: "文件系统版本不能为空", trigger: "blur" },
        ],
        DciProductModelIDs: [
          { required: true, message: "产品型号不能为空", trigger: "blur" },
        ],
        PublishAt: [
          { required: true, message: "发布日期不能为空", trigger: "blur" },
        ],
        IsDefault: [
          {
            required: true,
            message: "是否产品默认版本不能为空",
            trigger: "blur",
          },
        ],
        IsPublic: [
          {
            required: true,
            message: "是否公开发布不能为空",
            trigger: "blur",
          },
        ],
        Remark: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      submitting: false,
      // curDciProductModels: [],
      modelList: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      this.getModelList();
      // setTimeout(() => {//绑定配件型号和配件SN偶尔会出问题，用延时可避免
      // this.bindData();
      // }, 500);
    },
    getModelList() {
      this.$axios.get("dci/model/product/list?order=name").then(
        (response) => {
          this.modelList = response.data.data;
        },
        ({ response }) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // bindData() {
    //   if (this.item.ID && this.item.DciProductModel) {
    //     this.item.DciProductModel.forEach((mod) => {
    //       this.curDciProductModels.push({
    //         ID: mod.ID,
    //         NameNumber: mod.NameNumber,
    //       });
    //     });
    //   }
    // },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: this.item.ID
              ? `dci/pv/productversion/${itemData.ID}`
              : "dci/pv/productversion",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
